const getTitleFromDict = (
  n: string | number | undefined | null,
  dict: { [n: number | string]: string }
): string => (n ? dict[+n] : "");

export default getTitleFromDict;
